<template>
  <div class="qooBox-main flex flex-col overflow-hidden" :style="{ height: `${windowsHeight}px` }">
    <MainHeader v-if="$route.meta.layout == 'default'" />

    <!-- <transition name="overlay-fade" mode="out-in" @before-enter="beforeEnterPage" @enter="enterPage"> -->
      <!-- Page content with transition -->
      <div key="content" class="grow flex flex-col"
        :class="{ 'router-view-content': $route.meta.layout == 'default' }"
        :style="{ height: `${windowsHeight - 72}px` }">
        <transition mode="out-in" @before-enter="beforeEnter" @enter="enter" @before-leave="beforeLeave" @leave="leave">
          <router-view />
        </transition>
      </div>
    <!-- </transition> -->

    <!-- Overlay Loader
    <transition name="fade" mode="out-in" @before-enter="beforeEnterOverlay" @enter="enterOverlay"
      @leave="leaveOverlay">
      <FirstLoadOverlay v-if="isLoading" :isLoading="showOverlay" key="loader" @onComplete="animationCompleteHandler" />
    </transition> -->
    <!-- Popup Modal -->
    <popup-modal :w="windowsWidth > 768 ? '60%' : '100%'" :headerClass="'!mb-[18px]'"
      class="max-md:!items-start max-md:!h-full"
      classList="p-4 sm:p-4 md:py-6 md:px-6 mainList rounded-[14px] max-md:max-w-[100%] max-md:!h-full max-md:max-h-[100%] max-md:w-[100%] hide-scrollbar "
      @close="worksheet.popupMainWorksheet = false" v-show="worksheet.popupMainWorksheet"
      :title="'Add suite to your worksheet:'" :typeClose="'text'">
      <div>
        <div v-if="
          worksheet.popupMainWorksheet &&
          floorplan &&
          floorplan.floorplanList &&
          floorplan.floorplanList.length
        ">
          <tablePopupWorksheet :classSelection="'!mt-[34px]'" :btnPos="'bottom'" :isTitle="false"
            @close="handleClosePopup()" @save="save" :floorplanList="floorplan.floorplanList" :selected="selected"
            :worksheetList="worksheet.worksheetId" @showDet="showDet" />
        </div>
      </div>
    </popup-modal>
  </div>
</template>

<script setup>
import gsap from "gsap";
import PopupModal from "@/components/base/PopupModalAnimation.vue";

import tablePopupWorksheet from "@/components/worksheet/tablePopupWorksheet.vue";
import { useWindowSize } from "@vueuse/core";
import MainHeader from "@/components/base/MainHeader";
import {
  ref,
  onBeforeMount,
  onMounted,
  watch
} from "vue";
import { useStore } from "@/store/loading.js";
import { useWorksheets } from "@/store/worksheet.js";
import { useFloorplan } from "@/store/floor.js";
import { useRoute } from 'vue-router';

const route = useRoute();
const { height: windowsHeight, width: windowsWidth } = useWindowSize();
const store = useStore();
const worksheet = useWorksheets();
// handle overlay preloader
const popupMainWorksheetModels = ref(false);

let floorplan = {};
const selected = ref(-1);




// GSAP animations for the page transition
// const beforeEnterPage = (el) => {
//   if (route.name === 'home') {
//     gsap.set(el, { opacity: 1, x: 0 });
//     return;
//   }
//   gsap.set(el, { opacity: 0, x: 50 });
// };
// const enterPage = (el, done) => {
//   if (route.name === 'home') {
//     done();
//     return;
//   }
//   gsap.to(el, {
//     opacity: 1,
//     x: 0,
//     duration: 0.8,
//     ease: "power2.out",
//     onComplete: done,
//   });
// };


// GSAP animations for the router-view content
const beforeEnter = (el) => {
  if (route.name === 'home') {
    el.style.transform = "none";
    el.style.opacity = "1";
    return;
  }
  el.style.transform = "translateX(-100vw)";
};
const enter = (el, done) => {
  if (route.name === 'home') {
    el.style.transform = "none";
    el.style.opacity = "1";
    done();
    return;
  }
  gsap.to(el, {
    duration: 1,
    opacity: 1,
    translateX: "0vw",
    ease: "sine.inOut",
    onComplete: done,
  });
};
const beforeLeave = (el) => {
  if (route.name === 'home') {
    el.style.transform = "none";
    el.style.opacity = "1";
    return;
  } else if (route.name === 'floorplans' && route.query.full_3d === 'true') {
    el.style.transform = "none";
    el.style.opacity = "0";
    return;
  }
  el.style.transform = "translateX(0vw)";
};

const leave = (el, done) => {
  if (route.name === 'home') {
    el.style.transform = "none";
    el.style.opacity = "1";
    done();
    return;
  } else if (route.name === 'floorplans' && route.query.full_3d === 'true') {
    el.style.transform = "none";
    gsap.to(el, {
      duration: 1.5,
      opacity: 0,
      ease: "sine.inOut",
    });
    done();
    return;
  }
  gsap.to(el, {
    duration: 1,
    opacity: 1,
    translateX: "100vw",
    ease: "sine.inOut",
    onComplete: done,
  });
};

const handleClosePopup = () => {
  worksheet.popupMainWorksheet = false;
  selected.value = -1;
};

onBeforeMount(() => {
  // matomo
  const projectId = localStorage.getItem("project_id");
  const organizationId = localStorage.getItem("organization_id");
  const userId = localStorage.getItem("user_id");
  const email = localStorage.getItem("email");

  if (userId) {
    window._paq.push(["setUserId", userId]);
  }
  if (email) {
    window._paq.push(["setCustomDimension", 1, email]);
  }
  if (organizationId) {
    window._paq.push(["setCustomDimension", 2, String(organizationId)]);
    window._paq.push(["setCustomDimension", 5, String(organizationId)]);
  }
  if (projectId) {
    window._paq.push(["setCustomDimension", 3, String(projectId)]);
    window._paq.push(["setCustomDimension", 4, String(projectId)]);
  }
  floorplan.ensureFloorplanLength();
  worksheet.ensureWorksheetsLength();
});

onMounted(() => {
  // if (store.numberOfAjaxCAllPending === 0) {
  //   setTimeout(() => {
  //     showOverlay.value = false;
  //   }, 4000);
  // }
  floorplan = useFloorplan();
  worksheet.ensureWorksheetsLength();
  if (store.numberOfAjaxCAllPending == 0) {
    store.mutationer({ isLoading: false });
  }
});

watch(
  () => worksheet.popupMainWorksheet,
  () => {
    console.log("watch1");

    if (popupMainWorksheetModels.value != worksheet.popupMainWorksheet)
      popupMainWorksheetModels.value = worksheet.popupMainWorksheet;
      selected.value = -1;
  },
);

watch(
  () => popupMainWorksheetModels,
  () => {
    console.log("watch2");

    if (popupMainWorksheetModels.value != worksheet.popupMainWorksheet)
      worksheet.popupMainWorksheet = popupMainWorksheetModels.value;
  },
);

const save = (e) => {
  worksheet.addWorksheet(e);
  worksheet.popupMainWorksheet = false;
};

const showDet = (e) => {
  selected.value = selected.value === e ? -1 : e;
};
</script>

<style lang="scss">
.mainList {
  .floorplans .vgt-table.bordered th {
    font-size: 16px;
    font-weight: 500;
  }

  h3 {
    font-size: 16px !important;
    font-weight: 500 !important;
  }

  .vgt-responsive {
    height: 40vh !important;
    min-height: 20vh;
    max-height: calc(100vh - 20.5rem);
  }

  .vgt-table {
    width: 100%;

    thead {
      th {
        text-align: start;
      }

      tr th:first-child {
        max-width: 80px;
      }
    }

    colgroup {
      col:first-child {
        max-width: 80px;
        width: 80px;
      }
    }

    td {
      .grid {
        padding: 16px;
      }
    }
  }
}

.g {
  color: #ef45234d;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
